/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OauthLoginResponse } from '../models/OauthLoginResponse';
import type { PasswordDto } from '../models/PasswordDto';
import type { ProxyRequestDto } from '../models/ProxyRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProxyControllerService {

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static proxyRequest(
        requestBody: ProxyRequestDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/http-proxy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validator
     * @param requestBody
     * @returns OauthLoginResponse OK
     * @throws ApiError
     */
    public static getValidatorApiAccessToken(
        validator: string,
        requestBody: PasswordDto,
    ): CancelablePromise<OauthLoginResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/http-proxy/validator-api-access-token',
            query: {
                'validator': validator,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

}
